import React from 'react';
import { Home, Map, Fish, ShoppingBag, Users } from 'lucide-react';
import { Screen } from '../types/navigation';
interface BottomNavProps {
  currentScreen: Screen;
  onNavigate: (screen: Screen) => void;
}
export function BottomNav({
  currentScreen,
  onNavigate
}: BottomNavProps) {
  // Only show nav on main app screens
  const mainScreens = ['feed', 'events', 'go-fish', 'catches', 'friends'];
  if (!mainScreens.includes(currentScreen)) return null;
  const navItems = [{
    id: 'feed',
    icon: Home,
    label: 'Feed'
  }, {
    id: 'events',
    icon: Map,
    label: 'Events'
  }, {
    id: 'go-fish',
    icon: Fish,
    label: 'Go Fish'
  }, {
    id: 'catches',
    icon: ShoppingBag,
    label: 'Catches'
  }, {
    id: 'friends',
    icon: Users,
    label: 'Friends'
  }];
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-2 flex justify-between items-center z-50 pb-safe" data-id="element-11">
      {navItems.map(item => {
      const isActive = currentScreen === item.id;
      return <button key={item.id} onClick={() => onNavigate(item.id as Screen)} className={`flex flex-col items-center justify-center w-16 py-1 space-y-1 transition-colors ${isActive ? 'text-blue-500' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-12">
            <item.icon className={`w-6 h-6 ${isActive ? 'fill-current' : ''}`} strokeWidth={isActive ? 2.5 : 2} data-id="element-13" />
            <span className="text-[10px] font-medium" data-id="element-14">{item.label}</span>
          </button>;
    })}
    </div>;
}